export const getFieldName = (formRoot: string, fieldName: string) =>
  [formRoot, fieldName].filter((item) => item).join(".")
